import { firebase } from '../firebase/firebaseConfig'

const PRESIGN_URL = process.env.REACT_APP_UPLOAD_PRESIGN_URL

// Firebase ID token is required by the presign server (Authorization: Bearer <token>).
const getAuthToken = async () => {
	try {
		const token = await firebase.auth().currentUser?.getIdToken()
		if (token) return token
	} catch (error) {
		console.error('Failed to refresh Firebase ID token for presign request', error)
	}
	return JSON.parse(localStorage.getItem('token') || '{}')?.token
}

// Requests a presigned S3 PUT URL from the abstracted presign server.
export const getPresignedUploadUrl = async ({ key, contentType, contentLength }) => {
	if (!PRESIGN_URL) {
		throw new Error('REACT_APP_UPLOAD_PRESIGN_URL is not configured')
	}
	const token = await getAuthToken()
	const response = await fetch(PRESIGN_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ key, contentType, contentLength }),
	})
	if (!response.ok) {
		throw new Error(`Presign request failed with status ${response.status}`)
	}
	return response.json()
}

// Uploads a File/Blob to S3 via a presigned PUT URL and resolves with the
// durable publicUrl to store/display. The browser sets Content-Length
// automatically to file.size, matching the value sent to the presign server.
export const uploadFileToS3 = ({ file, key, onProgress }) =>
	new Promise((resolve, reject) => {
		const contentType = file.type || 'application/octet-stream'

		getPresignedUploadUrl({ key, contentType, contentLength: file.size })
			.then(({ uploadUrl, publicUrl }) => {
				const xhr = new XMLHttpRequest()
				xhr.open('PUT', uploadUrl)
				xhr.setRequestHeader('Content-Type', contentType)

				xhr.upload.onprogress = (event) => {
					if (event.lengthComputable && onProgress) {
						onProgress({ percent: Math.round((event.loaded / event.total) * 100) })
					}
				}
				xhr.onload = () => {
					if (xhr.status >= 200 && xhr.status < 300) {
						resolve(publicUrl)
					} else {
						reject(new Error(`S3 upload failed with status ${xhr.status}`))
					}
				}
				xhr.onerror = () => reject(new Error('S3 upload network error'))
				xhr.send(file)
			})
			.catch(reject)
	})
